var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircletick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.12695C6.48 2.12695 2 6.60695 2 12.127C2 17.647 6.48 22.127 12 22.127C17.52 22.127 22 17.647 22 12.127C22 6.60695 17.52 2.12695 12 2.12695ZM12 20.127C7.59 20.127 4 16.537 4 12.127C4 7.71695 7.59 4.12695 12 4.12695C16.41 4.12695 20 7.71695 20 12.127C20 16.537 16.41 20.127 12 20.127ZM15.88 8.41695L10 14.297L8.12 12.417C7.73 12.027 7.1 12.027 6.71 12.417C6.32 12.807 6.32 13.437 6.71 13.827L9.3 16.417C9.69 16.807 10.32 16.807 10.71 16.417L17.3 9.82695C17.69 9.43695 17.69 8.80695 17.3 8.41695C16.91 8.02695 16.27 8.02695 15.88 8.41695Z",
    fill: "#007F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircletick);
export default __webpack_public_path__ + "static/media/circle tick.b98478ec8d18c7f1511a951e8b1f0057.svg";
export { ForwardRef as ReactComponent };